import { ChargifyPriceQuery } from '../vsSubscriptionApiInjected';

export function transformChargifyPrice(
  resp: ChargifyPriceQuery
): Record<string, string> {
  return Object.fromEntries(
    resp.chargify_price.map(({ price, plan_id }) => [plan_id, price])
  );
}
